import { IMG_PREVIOUS_REFUND } from '@repo/assets';
import { Modal } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onClick: () => void;
  nationality: string;
};

export const PreviousRefundModal = ({
  isOpen,
  onClose,
  onClick,
  nationality,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      hasBackdrop
      wrapperStyle={{ width: '100%', maxWidth: '335px' }}
    >
      <Modal.Header>
        <TitleWrapper>
          <img src={IMG_PREVIOUS_REFUND} alt='' width={72} />
          {nationality === 'KOR'
            ? '기존 환급 정보가 존재합니다.'
            : 'Previous Refund Information Exists'}
        </TitleWrapper>
      </Modal.Header>
      <BodyWrapper>
        {nationality === 'KOR'
          ? '이전에 입력한 송금 정보를 불러옵니다.'
          : 'Would you like to load the previously entered refund information?'}
      </BodyWrapper>
      <Modal.Footer>
        <Modal.Button onClick={onClose} variant='cancel' size='lg'>
          {nationality === 'KOR' ? '새로 입력하기' : 'Enter new'}
        </Modal.Button>
        <Modal.Button onClick={onClick} size='lg'>
          {nationality === 'KOR' ? '불러오기' : 'Load'}
        </Modal.Button>
      </Modal.Footer>
    </Modal>
  );
};

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  line-height: 150%;
  gap: 12px;
  width: 100%;
`;

const BodyWrapper = styled.div`
  color: var(--KTP-Grayscale-50, var(--KTP-Color-Mono-50, #80848a));
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
  margin-top: 16px;
`;
